import DashboardLayout from "../../../../Layouts/DashboardLayout";
import ContentBodyWrapper from "../../../../Layouts/Containers/ContentBodyWrapper";
import ContentBodyHeader from "../../../../Layouts/Containers/ContentBodyHeader";
import reactRouteList from "../../../../config/react-route-list-config";
import { useParams } from "react-router-dom";
import RoleEdit from "../../../../components/Forms/RoleEdit";
import RolePermissionContexttProvider from "../../../../contexts/RolePermissionContext";
import { useTranslation } from "react-i18next";
import { changeBrowserTabTitle } from "../../../../utils/Browser";
import ButtonBlack from "../../../../components/Buttons/ButtonBlack";

export default function RoleEditPage() {
    let { id } = useParams();
    changeBrowserTabTitle("Edit Role");
    const breadCrumbLink =
        reactRouteList.loggedRoutes.edit_role.link + "/" + id;
    const breadCrumbItem = id;
    const [t] = useTranslation();
    const buttons = (
        <ButtonBlack
            to={reactRouteList.loggedRoutes.role_list}
            icon={"material-symbols:arrow-back"}
        >
            {t("Back")}
        </ButtonBlack>
    );

    return (
        <>
            <DashboardLayout>
                <ContentBodyWrapper showFooter={true}>
                    <ContentBodyHeader
                        info={{
                            title: t("Edit Role"),
                        }}
                        breadcrumb={[
                            {
                                linkitem: t("Roles"),
                                link: reactRouteList.loggedRoutes.role_list,
                            },
                            {
                                linkitem: t("Edit"),
                                link: breadCrumbLink,
                            },
                            { linkitem: breadCrumbItem, link: breadCrumbLink },
                        ]}
                        buttons={buttons}
                    />
                    <RolePermissionContexttProvider>
                        <RoleEdit id={id} />
                    </RolePermissionContexttProvider>
                </ContentBodyWrapper>
            </DashboardLayout>
        </>
    );
}
